import { PermissionAreaDto } from '@/api/generated';

export type PermissionMatrixTranslation = {
  area: Record<PermissionAreaDto, string>;
  areaColumn: string;
  inheritedAndSelectedPermission: string;
  inheritedPermission: string;
  level: {
    CREATE: string;
    DELETE: string;
    EDIT: string;
    READ: string;
    SPECIAL: string;
  };
  notApplicable: string;
  selectedCount: string;
  toggleArea: string;
};

export const permissionMatrixTranslation: PermissionMatrixTranslation = {
  area: {
    ANNOUNCEMENT: 'Ogłoszenia',
    CAR: 'Samochody',
    COMMISSION: 'Prowizje',
    CONTACT: 'Kontakty',
    DICTIONARY: 'Słowniki',
    EMERGENCY_CONTACT: 'Kontakty alarmowe',
    OFFER: 'Oferty',
    PROCESS: 'Procesy',
    RECURRING_RESERVATION: 'Rezerwacje stałe',
    REPORT: 'Raporty',
    ROLE: 'Role i uprawnienia',
    SUPERVISOR: 'Opiekunowie',
    TASK: 'Zadania',
    USER: 'Użytkownicy',
  },
  areaColumn: 'Obszar',
  inheritedAndSelectedPermission: '{{label}} (z roli, nadane też dodatkowo)',
  inheritedPermission: '{{label}} (z roli)',
  level: {
    CREATE: 'Tworzenie',
    DELETE: 'Usuwanie',
    EDIT: 'Edycja',
    READ: 'Odczyt',
    SPECIAL: 'Uprawnienia specjalne',
  },
  notApplicable: 'Nie dotyczy',
  selectedCount: 'Zaznaczono {{selected}} z {{total}}',
  toggleArea: 'Wszystkie uprawnienia obszaru {{area}}',
};
